import classnames from 'classnames';
import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import style from '../migration-plan-modal.module.less';

export const PlanLineItemDetail = ({ lineItemTitle, lineItemValue, promotionalLineItemValue }) => {
  const isPriceAdjusted = Boolean(promotionalLineItemValue);

  return (
    <FlexColumn className={style['line-item-detail']}>
      <Text className={style['line-item-title']} value={lineItemTitle} />
      <FlexRow className={style['line-item-value-row']}>
        <Text
          className={classnames(style['line-item-value'], { [style['is-discounted']]: isPriceAdjusted })}
          textType={isPriceAdjusted ? TextType.Description : TextType.H3}
          value={lineItemValue}
        />
        {isPriceAdjusted && <Text className={style['line-item-value']} textType={TextType.H3} value={promotionalLineItemValue} />}
      </FlexRow>
    </FlexColumn>
  );
};
